const {ccclass, property} = cc._decorator;

/**
 * 玩家节点
 */
@ccclass
export default class PlayerItemNode extends cc.Component {

    @property(cc.Label)
    label: cc.Label = null;

    onLoad () {}

    start () {

    }

    bindData( lbContent : string ){
        this.label.string = `${lbContent}`;
    }
    // update (dt) {}
}
